export default "__VITE_ASSET__owqYATHf__"